<template class="full-height">
  <div class="coupon-category-app-container" style="position: relative; height: 100%">
    <el-dialog
      v-if="form.id && form.id > 0"
      append-to-body
      :title="form.categoryName + '子分類維護'"
      width="60%"
      :visible.sync="dialogSubVisible"
    >
      <sub-Category :parent-id="form.id" :parent-name="form.categoryName"> </sub-Category>
    </el-dialog>

    <!-- 票券分類維護 -->
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item :label="funcName + '名稱'">
            <el-input v-model="form.categoryName"></el-input>
          </el-form-item>

          <el-form-item label="狀態">
            <!-- <el-radio-group v-model="form.disabled">
              <el-radio :label="true">停用</el-radio>
              <el-radio :label="false">啟用</el-radio>
            </el-radio-group> -->

            <el-switch
              v-model="form.disabled"
              active-text="停用"
              inactive-text="啟用"
              active-color="#ff4949"
              inactive-color="#13ce66"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :min="1" label="排序"></el-input-number>
          </el-form-item>

          <el-form-item :label="'子分類維護'">
            <el-button size="mini" type="success" @click="addSubCategory">維護子分類</el-button>
          </el-form-item>
        </el-form>

        <!-- <el-row>
          <el-col :span="12">
           
          </el-col>
          <el-col :span="12" v-if="form.id && form.id > 0">
            <el-form ref="formSub" :label-width="formLabelWidth">
              
            </el-form>
          </el-col>
        </el-row> -->
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="saveData" style="color: #4b4b4b">儲 存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input v-model="listQuery.qry" placeholder="輸入分類" @keyup.enter.native="getList" />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <!-- <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item :label="funcName + '查詢'">
          <el-input v-model="listQuery.qry" :placeholder="'輸入' + funcName" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh"
          ></el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '名稱'">
          <template slot-scope="scope">
            <span>{{ scope.row.categoryName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '排序'" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">{{
              scope.row.disabled ? '停用' : '啟用'
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="刪除" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteData(scope.row)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import SubCategory from '@/views/ita/appManage/coupon/couponCategory/couponSubCategory.vue'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import checkPermission from '@/utils/permission' // 权限判断函数

import { saveCouponCategory, getCouponCategory, deleteCouponCategory } from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'

var defaultForm = {
  id: null,
  categoryName: null,
  disabled: false,
  sort: 1,
}

export default {
  name: 'CouponCategory',
  components: {
    SubCategory,
    Pagination,
  },
  data() {
    return {
      funcName: '票券分類',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogSubVisible: false,
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+sort',
        agencyCode: null,
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    checkPermission,
    async refresh() {
      let vm = this
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+sort',
        agencyCode: null,
      }
      await vm.getList()
    },
    addSubCategory() {
      let vm = this
      vm.dialogSubVisible = true
    },
    addData(row) {
      debugger
      let vm = this
      vm.form = defaultForm
      vm.form.sort = vm.list.length + 1
      vm.dialogVisible = true
    },
    editData(row) {
      let vm = this
      vm.form = row
      vm.dialogVisible = true
    },
    saveData() {
      if (!confirm(`確定儲存`)) {
        return
      }

      let vm = this
      vm.dialogLoading = true

      //特需權限可以看到全部票券 便免編輯票券會帶入agencyCode所以做此判斷
      if (
        !checkPermission(['APP-ADMIN']) &&
        !checkPermission(['ITA-DEV']) &&
        !checkPermission(['ITA-ADMIN']) &&
        !checkPermission(['ITA-BOSS'])
      ) {
        if (!vm.form.agencyCode && vm.$store.getters.userInfo.agencyCode) {
          vm.form.agencyCode = vm.$store.getters.userInfo.agencyCode
            ? vm.$store.getters.userInfo.agencyCode
            : null
        }
      }

      saveCouponCategory(vm.form).then(response => {
        vm.getList()
        vm.dialogLoading = false
        vm.dialogVisible = false
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      })
    },
    deleteData(row) {
      if (!confirm(`確定刪除【${row.categoryName}】?`)) {
        return
      }
      debugger

      let vm = this
      vm.dialogLoading = true
      deleteCouponCategory({ key: row.id }).then(response => {
        vm.getList()
        vm.dialogLoading = false
        vm.dialogVisible = false
        Message({
          message: '資料刪除完成',
          type: 'success',
          duration: 5 * 1000,
        })
      })
    },
    async getList() {
      this.listLoading = true
      this.listQuery.agencyCode = this.$store.getters.userInfo.agencyCode
        ? this.$store.getters.userInfo.agencyCode
        : null

      await getCouponCategory(this.listQuery).then(response => {
        this.list = response.data.data

        this.total = response.data.total
        this.listLoading = false
      })
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
